// Privacy-conscious event wrapper over the PostHog snippet already loaded by the platform.
// No personal data is ever passed — only page/entity identifiers.
export const track = (event, props = {}) => {
  try {
    window.posthog?.capture?.(`elentara_${event}`, props);
  } catch {
    /* analytics must never break the experience */
  }
};

export const EVENTS = {
  HOME_VIEW: "home_view",
  CASE_STUDY_VIEW: "case_study_view",
  CAPABILITY_VIEW: "capability_view",
  EXPERIMENT_VIEW: "experiment_view",
  START_PROJECT_CLICK: "start_project_click",
  BRIEF_SUBMIT: "brief_submit",
  ENTER_EXPERIENCE_CLICK: "enter_experience_click",
};
